import React from 'react';

import { EmailInput, PhoneInput } from '../ui/Inputs';

import styles from './Contact.module.scss';

const Contact = ({ email, onEmailChange, phone_number, onPhoneChange, handleSubmit, errors }) => (
  <div className="mb-2">
    <EmailInput
      className="mb-3"
      value={email}
      onChange={onEmailChange}
      placeholder="E-postadress"
      error={errors?.email}
    />
    <PhoneInput
      className="mb-3"
      value={phone_number}
      onChange={onPhoneChange}
      placeholder="Telefonnummer"
      error={errors?.phone_number}
    />
    <button type="button" className={styles.contact} onClick={handleSubmit}>
      Fortsätt
    </button>
  </div>
);

export default Contact;
